/**
 * 全局自适应适配器（H5/Web 端）
 * 控制 JDDevice.getRpx 计算出的 px 值不超过上限
 *
 * 原始逻辑：getRpx(v) = v * Device.width / 750
 * 替换为：  getRpx(v) = v * min(realWidth, MAX_WIDTH) / 750
 * MAX_WIDTH 即视口宽度上限，超过后不再放大
 */

if (typeof window !== 'undefined') {
  var JDDevice;
  try {
    JDDevice = require('@jdreact/jdreact-core-lib').JDDevice;
  } catch (e) {
    try { JDDevice = require('@jdreact/jdreact-core-lib/Libraries/JDDevice'); } catch (_) {}
  }

  if (JDDevice && typeof JDDevice.getRpx === 'function') {
    var MAX_WIDTH = 400; // 视口宽度超过此值后，getRpx 不再放大

    JDDevice.getRpx = function (value) {
      var realWidth = document.documentElement.clientWidth || window.innerWidth;
      var width = Math.min(realWidth, MAX_WIDTH);
      return Math.floor(value * width / 750);
    };
  }
}